import { render } from "./index.vue?vue&type=template&id=4e5ecb83&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4e5ecb83"

export default script